import { useTranslation } from "react-i18next";

export default function SkolkovoBanner() {
  const { t } = useTranslation();

  return (
    <section className="skolkovo-banner">
      <div className="skolkovo-banner__container">
        <div className="skolkovo-banner__content">
        <div className="skolkovo-banner__logo">
          <img 
            src="assets/img/skolkovo.svg" 
            alt="Skolkovo Innovation Center"
          />
        </div>
          <p className="skolkovo-banner__text">
            {t("skolkovo::Research conducted by ENERGO TECHNOLOGIES LLC with grant support from Skolkovo Foundation")}
          </p>
        </div>
      </div>
    </section>
  );
}
